<template>
  <div class="header">
    <img width="30px" height="22px" src="../assets/logo.png">
    <p>担当运营管理系统</p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .header{
    width:100%;
    height:60px;
    background:rgba(255,255,255,1);
    box-shadow:0px 5px 9px 0px rgba(36,121,237,0.1);
    display: flex;
    >img{
      margin-top: 20px;
      margin-left: 260px;
    }
    >p{
      font-size:16px;
      font-weight:400;
      color:rgba(50,50,50,1);
      margin-top: 20px;
      margin-left: 10px;
    }
  }
</style>